import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';

import {
    ContextActionType,
    FlexyTabs,
    useDumbActionsContext,
} from '@europrocurement/flexy-components';

import { PackagePanel } from './Package';
import { CatalogPanel } from './Catalog';
import { OfferPanel } from './Offer';
import { OfferAdditionalFieldPanel } from './AdditionalField';
import { GroupPanel } from './Group';

/**
 * Dashboard "Configuration des offres commerciales".
 * Regroupe les onglets accessibles aux gestionnaires d'offres (rôle ADMIN_OFFRES) :
 * Offre, Packages, Catalogues, Champs complémentaires et Groupements.
 *
 * Le chargement des données partagées est assuré par le layout parent (ConfigLayout).
 */
const OfferConfigDashboard: React.FunctionComponent = function () {
    const contextActions: ContextActionType[] = useMemo(() => [], []);
    useDumbActionsContext(contextActions);

    const tabs = useMemo(
        () => [
            {
                tabTitle: 'Offre',
                tabPanel: <OfferPanel />,
                tabName: 'offre',
            },
            {
                tabTitle: 'Packages',
                tabPanel: <PackagePanel />,
                tabName: 'package',
            },
            {
                tabTitle: 'Catalogues',
                tabPanel: <CatalogPanel />,
                tabName: 'catalogue',
            },
            {
                tabTitle: 'Champs complémentaires',
                tabPanel: <OfferAdditionalFieldPanel />,
                tabName: 'champComplementaire',
            },
            {
                tabTitle: 'Groupements',
                tabPanel: <GroupPanel />,
                tabName: 'groupement',
            },
        ],
        [],
    );

    return (
        <Box>
            <Typography
                variant="h1"
                sx={{ marginBottom: 2 }}
            >
                Configuration des offres commerciales
            </Typography>

            <FlexyTabs
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',
                }}
                tabs={tabs}
                scrollbar={false}
            />
        </Box>
    );
};

export default OfferConfigDashboard;
